export default "__VITE_ASSET__5$BfdtZb__"